module.exports = __webpack_public_path__ + "static/img/bg_smarttransportation.fc01958f.jpg";